import React, { useState, useEffect, useCallback } from "react";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import {
    Grid,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Typography,
    TablePagination,
    Backdrop,
    CircularProgress,
    Checkbox,
    Chip,
    Avatar,
    Tooltip
} from "@material-ui/core";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import PageTitle from "../../components/PageTitle";
import ViewIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import { toast } from "react-toastify";
import { Autocomplete } from "@material-ui/lab";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import Notification from "../../components/Notification";
import useStyles from "../../themes/style.js";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useLocation, useHistory } from "react-router-dom";

const positions = [toast.POSITION.TOP_RIGHT];
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function AssignVendors() {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const queryParams = new URLSearchParams(location.search);
    const requirementName = queryParams.get("requirement_name");
    const requirementIdParam = queryParams.get("requirement_id");

    const token = localStorage.getItem("token");
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const mobileQuery = useMediaQuery('(max-width:600px)');
    const [userName, setUserName] = useState([]);
    const [selectedRecruiters, setSelectedRecruters] = useState([]);
    const [vendorsData, setVendorsData] = useState([]);

    const assignSchema = Yup.object().shape({
        recruiterId: Yup.array()
            .of(
                Yup.object().shape({
                    id: Yup.string().required("Recruiter ID is required"),
                })
            )
            .min(1, "At least one recruiter must be selected")
            .required("Recruiter selection is required"),
    });

    const onRemoveSelectedRecruiters = (id) => () => {
        setSelectedRecruters((value) => value.filter((v) => v.id !== id));
    };

    const {
        control: assignControl,
        formState: { errors: assignErrors, isSubmitting: assignIsSubmitting },
        handleSubmit: assignSubmit,
    } = useForm({
        mode: "onSubmit",
        resolver: yupResolver(assignSchema),
    });

    const [page, setPage] = useState(0);
    const [currerntPage, setCurrerntPage] = useState(1);

    const HeaderElements = () => <>Total : {count}</>;
    var [errorToastId, setErrorToastId] = useState(null);
    function sendNotification(componentProps, options) {
        return toast(
            <Notification
                {...componentProps}
                className={classes.notificationComponent}
            />,
            options,
        );
    }

    function handleNotificationCall(notificationType, message) {
        var componentProps;

        if (errorToastId && notificationType === "error") return;

        switch (notificationType) {
            case "info":
                componentProps = {
                    type: "feedback",
                    message: message,
                    variant: "contained",
                    color: "primary",
                };
                break;
            case "error":
                componentProps = {
                    type: "message",
                    message: message,
                    variant: "contained",
                    color: "secondary",
                };
                break;
            default:
                componentProps = {
                    type: "shipped",
                    message: message,
                    variant: "contained",
                    color: "success",
                };
        }

        var toastId = sendNotification(componentProps, {
            type: notificationType,
            position: positions[2],
            progressClassName: classes.progress,
            onClose: notificationType === "error" && (() => setErrorToastId(null)),
            className: classes.notification,
            autoClose: notificationType === "error" ? false : 5000
        });

        if (notificationType === "error") setErrorToastId(toastId);
    }

    const getAssigendVendorsData = useCallback(async () => {
        setLoader(true);
        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/getAssigendData`,
            data: {
                roleName:"SUBCONTRACT",
                requirementId: requirementIdParam,
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {
            if (response.data.status === true) {
                setVendorsData(response.data.data)
                setCount(response.data.count);
            }
            setLoader(false);
        }).catch((err) => {
            setLoader(false);
            console.log(err)
        });
    }, []);

    const getUserName = useCallback(async () => {
        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/allRecruiterList`,
            data: {},
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        })
            .then(function (response) {
                if (response.data.status === true) {
                    setLoader(false);
                    const responseData = response.data.data
                    const freelanceUsers = responseData.filter(item => item.user.roleName === "SUBCONTRACT")
                    setUserName(freelanceUsers);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        getAssigendVendorsData();
        getUserName();
    }, [getAssigendVendorsData, getUserName]);


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setCurrerntPage(newPage + 1);
        setLoader(true);

        axios({
            method: "post",
            url: `${process.env.REACT_APP_SERVER}admin/getAssigendData`,
            data: {
                page: newPage + 1,
                roleName:"SUBCONTRACT",
                requirementId: requirementIdParam,
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
            },
        }).then(function (response) {
            if (response.data.status === true) {
                setVendorsData(response.data.data);
                setCount(response.data.count);
                setLoader(false);
            }
            setLoader(false);
        }).catch((err) => {
            setLoader(false);
            console.log(err)
        });
    };

    function handleAssignRequirements(values) {
        return new Promise((resolve) => {
            setLoader(true);
            const selectRecruitersID = selectedRecruiters.map(item => item.id)

            axios({
                method: "post",
                url: `${process.env.REACT_APP_SERVER}admin/assignMulitpleRecuritersToRequirements`,
                data: {
                    roleName:"SUBCONTRACT",
                    freelancerecruiters: selectRecruitersID,
                    requirementId: requirementIdParam
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }).then(function (response) {
                resolve();
                if (response.data.status === true) {
                    handleNotificationCall("success", response.data.message);
                    getAssigendVendorsData();
                } else {
                    handleNotificationCall("error", response.data.message);
                }
                setLoader(false);
            });
        });
    }

    const handleRemoveRecruiter = async (recruiterId) => {
        try {
            setLoader(true);
            const response = await axios.post(`${process.env.REACT_APP_SERVER}CC/removeAssignedRequirements`, {
                id: recruiterId,
                requirementId: requirementIdParam,
            }, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                }
            });
            setLoader(false);
            if (response.data.status === true) {
                handleNotificationCall("success", response.data.message);
                getAssigendVendorsData();
            } else {
                handleNotificationCall("error", response.data.message);
            }
        } catch (error) {
            setLoader(false);
            console.error('Error removing recruiter:', error);
        }
    };

    const viewVendorDetails = (item) => {
        const userId = item.recruiter?.id
        const firstName = item.recruiter?.firstName;
        const lastName = item.recruiter?.lastName;
        const userFullName = `${firstName} ${lastName}`;
        history.push(`/app/vendor/requirements?user_id=${userId}&user_name=${userFullName}`)
    }

    return (
        <>
            <Grid container direction="row" spacing={2} className={classes.heading}>
                <Grid item xs={9} sm={7} md={8} lg={6}>
                    <PageTitle title={`Assign Vendor for ${requirementName}`} />
                </Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid xs={8} lg={6} >
                    <form onSubmit={assignSubmit(handleAssignRequirements)}>
                        <div style={{ margin: "14px 14px 0px 14px" }}>
                            <div className={classes.selectedAssignedRecruitersContainer}>
                                {selectedRecruiters.map((option) => {
                                    const firstName = option.firstName;
                                    const lastName = option.lastName;
                                    let chipLabel = `${firstName} ${lastName}`;
                                    return (
                                        <Chip
                                            key={option.id}
                                            label={chipLabel}
                                            onDelete={onRemoveSelectedRecruiters(option.id)}
                                            avatar={<Avatar> {firstName.split("")[0]}</Avatar>}
                                            className={classes.EditRecUserChip}
                                            clickable
                                            color="primary"
                                            variant="outlined"
                                        />
                                    )
                                })}
                            </div>
                            <div style={{ display: "flex", alignItems: "end", gap: "10px" }}>
                                <FormControl>
                                    <InputLabel shrink htmlFor="recruiterId">  Vendors   </InputLabel>
                                    <Controller
                                        name="recruiterId"
                                        control={assignControl}
                                        render={({ field }) => (
                                            <Autocomplete
                                                {...field}
                                                multiple
                                                id="checkboxes-tags-demo"
                                                options={userName}
                                                value={selectedRecruiters}
                                                disableCloseOnSelect
                                                getOptionLabel={(option) => {
                                                    const firstName = option.firstName;
                                                    const lastName = option.lastName;
                                                    let label = `${firstName} ${lastName}`;
                                                    return label;
                                                }}
                                                onChange={(e, newValue) => {
                                                    field.onChange(newValue);
                                                    setSelectedRecruters(newValue)
                                                }}
                                                renderTags={() => null}
                                                renderOption={(option, { selected }) => {
                                                    const firstName = option.firstName;
                                                    const lastName = option.lastName;
                                                    let label = `${firstName} ${lastName}`;

                                                    return (
                                                        <div style={{ fontSize: "14px" }}>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={checkedIcon}
                                                                style={{ marginRight: 8, padding: 0 }}
                                                                checked={selected}
                                                            />
                                                            {label}
                                                        </div>
                                                    )
                                                }}
                                                renderInput={(params) => (
                                                    <TextField {...params} name="recruiterId" variant="filled" />
                                                )}
                                            />
                                        )}
                                    />
                                    <Typography variant="inherit" color="error" style={{ position: 'absolute', bottom: "-22px", left: 0 }}>
                                        {assignErrors.recruiterId?.message}
                                    </Typography>
                                </FormControl>

                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    disabled={assignIsSubmitting}
                                    type="submit"

                                    className={classes.mt16}
                                >
                                    Assign
                                </Button>
                            </div>
                        </div>
                    </form>
                </Grid>
                <Grid item xs={12}>
                    <MUIDataTable
                        title=""
                        options={{
                            textLabels: {
                                body: {
                                    noMatch: 'Oops! Matching record could not be found',
                                }
                            },
                            pagination: false,
                            sort: false,
                            selectableRows: "none",
                            search: false,
                            filter: false,
                            download: false,
                            print: false,
                            customToolbar: () => <HeaderElements />,
                            responsive: mobileQuery === true ? 'vertical' : 'standard',
                        }}
                        columns={[
                            {
                                name: "S.No",
                            },
                            {
                                name: "Actions",
                            },
                            {
                                name: "Name",
                            },

                            {
                                name: "Email",
                            },
                            {
                                name: "Mobile",
                            },
                            {
                                name: "Employee ID",
                            },
                            {
                                name: "Assigned On",
                            },
                            {
                                name: "Remove"
                            }
                        ]}
                        data={vendorsData.map((item, index) => {
                            return [
                                <>
                                    {currerntPage !== 0
                                        ? 10 * currerntPage - 10 + index + 1
                                        : index + 1}
                                </>,
                                <>
                                    <Grid container className={classes.space}>
                                        <Grid item xs className={classes.toolAlign}>
                                            <Tooltip
                                                title="View Vendor"
                                                placement="bottom"
                                                aria-label="view"
                                            >
                                                <ViewIcon
                                                    className={classes.toolIcon}
                                                    onClick={() => viewVendorDetails(item)}
                                                />
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </>,
                                item.recruiter?.firstName + " " + item.recruiter?.lastName,
                                item.recruiter.user?.email,
                                item.recruiter?.mobile,
                                item.recruiter?.employeeId,
                                moment(item.createdAt).format("DD-MM-YYYY"),
                                <>
                                    <Grid container className={classes.space}>
                                        <Grid item xs className={classes.toolAlign}>
                                            <Tooltip
                                                title="unassign Vendor"
                                                placement="bottom"
                                                aria-label="view"
                                            >
                                                <DeleteIcon
                                                    className={classes.toolIconDelete}
                                                    onClick={() => handleRemoveRecruiter(item.id)}
                                                />
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </>
                            ];
                        })}
                    />

                    <Grid container spacing={2} className={classes.pagination}>
                        <TablePagination
                            rowsPerPageOptions={[50]}
                            component="div"
                            count={count}
                            rowsPerPage={10}
                            page={page}
                            onPageChange={handleChangePage}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Backdrop className={classes.backdrop} open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default AssignVendors;